import { ERROR_BLOCK_DEFAULT_PROPS } from './constants/errorBlock.constant';
import type { TErrorBlock } from '@features/ErrorBlock/models/errorBlock.model';
import type { FC } from 'react';
import styles from './ErrorBlock.module.css';

const ErrorBlock: FC<TErrorBlock> = ({
  message,
  onClick,
  title = ERROR_BLOCK_DEFAULT_PROPS.title,
  buttonText = ERROR_BLOCK_DEFAULT_PROPS.buttonText
}) => (
  <div className={styles.errorContainer}>
    <div>
      <p className={styles.bold}>{title}</p>
      <p>{message}</p>
      <p>
        <a
          className={styles.errorButton}
          onClick={() => void onClick()}
          title={buttonText}
          role='button'
        >
          {buttonText}
        </a>
      </p>
    </div>
  </div>
);
export default ErrorBlock;
